const ComponentBase = require('../../base/ComponentBase');
const CommonUtil = require('../../utils/CommonUtil');
/**
 * @constructor
 * @classdesc 全屏
 * @augments G.base.ComponentBase
 * @alias G.common.FullScreen
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {String} [options.source] 全屏dom id，默认为地图所在dom
 * @example
 * //使用示例代码
 *         var fullScreen = new G.common.FullScreen({
 *             map:demo.emap
 *         });
 *          fullScreen.fullScreen();
 *          fullScreen.exit();
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        this._addFullScreenStyle();
    },

    /**
     * @inheritdoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
    },

    /**
     * @inheritdoc
     * 
     */
    unload() {
        ComponentBase.prototype.unload.call(this);
    },

    /**
     * 全屏
     * @method
     * @memberOf G.common.FullScreen.prototype
     * 
     */
    fullScreen() {
        this._handleFullScreen();
    },
     /**
     * 退出全屏
     * @method
     * @memberOf G.common.FullScreen.prototype
     * 
     */
    exit() {
        this._handleExit();
    },   
    /**
     * @inheritDoc
     */
    destroy() {
        ComponentBase.prototype.destroy.call(this);
    },
    //全屏处理
    _handleFullScreen () {
        if (!this._isFullScreenSupported()) {
            return;
        }
        var map = this.map;
        if (!map) {
            return;
        }
        if (!this._isFullScreen()) {
            var element;
            if (this.options.source) {
              element = typeof this.options.source === 'string' ?
                document.getElementById(this.options.source) :
                this.options.source;
            } else {
              element = document.getElementById(map.options.targetId);
            }
            if (this.keys_) {
                this._requestFullScreenWithKeys(element);
        
            } else {
                this._requestFullScreen(element);
            }
        }
    },
    //退出全屏
    _handleExit () {
        if (!this._isFullScreenSupported()) {
          return;
        }
        var map = this.map;
        if (!map) {
          return;
        }
        if (this._isFullScreen()) {
          this._exitFullScreen();
        } else {

        }
    },
    //浏览器适配全屏
    _requestFullScreen (element) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        }
    },
    //浏览器适配退出
    _exitFullScreen () {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
    },
    //全屏判定
    _isFullScreen () {
        return !!(
          document.webkitIsFullScreen || document.mozFullScreen ||
          document.msFullscreenElement || document.fullscreenElement
        );
    },
    //全屏支持判定
    _isFullScreenSupported () {
        var body = document.body;
        return !!(
          body.webkitRequestFullscreen ||
          (body.mozRequestFullScreen && document.mozFullScreenEnabled) ||
          (body.msRequestFullscreen && document.msFullscreenEnabled) ||
          (body.requestFullscreen && document.fullscreenEnabled)
        );
    },
    //增加全屏样式（适配ie）
    _addFullScreenStyle(){
        var domId;
        if (this.options.source) {
            domId = typeof this.options.source === 'string' ?
            this.options.source :this.options.source.id;
          } else {
            domId = this.map.options.targetId;
          }

        var styleElement = document.getElementById("fullscreen_style");
        if (!styleElement) {
            styleElement = document.createElement("style");
            styleElement.type="text/css";
            styleElement.id="fullscreen_style";
            document.getElementsByTagName("head")[0].appendChild(styleElement)
        }

        var moz_fullscreen_style="#"+domId+":-moz-full-screen {height: 100%;width: 100%;}";
        var webkit_fullscreen_style="#"+domId+":-webkit-full-screen {height: 100%;width: 100%;}";
        var ms_fullscreen_style="#"+domId+":-ms-fullscreen {height: 100%;width: 100%;}";
        var fullscreen_style="#"+domId+":fullscreen {height: 100%;width: 100%;}";
        styleElement.appendChild(document.createTextNode(moz_fullscreen_style));
        styleElement.appendChild(document.createTextNode(webkit_fullscreen_style));
        styleElement.appendChild(document.createTextNode(ms_fullscreen_style));
        styleElement.appendChild(document.createTextNode(fullscreen_style));
    }
});
module.exports = component;